/** The consumer-facing name lives here and nowhere else. The slug `blobland` is baked into infra. */
export const BRAND = 'Blobland'
export const TAGLINE = 'A tiny isometric town for blobs in hats.'
